import React from 'react';
import PublicHeader from '../../components/ui/PublicHeader';
import PublicFooter from '../../components/ui/PublicFooter';

const lines = [
  'شما تا حالا توی زندگی تون فرنگیس داشتید؟',
  'از همونا که نمیدونستی به کی بگی که چشماش، تو غصه زندونت کرد...',
  'تا حالا با مامانت بحثت شده؟',
  'از همونا که سخته بگی ببخشید، چون که تهش میدونی فقط بخاطر خودته...',
  'تا حالا دلتنگ رفیقت شدی؟',
  'نه اینکه دعوا کرده باشیا ! نه. همینجوری بی هوا.',
  'توام حرفهای نگفته که گفتنش سخته زیاد داری؟',
];

const AboutUs = () => {
  return (
    <div
      className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-blue-50"
      dir="rtl"
    >
      <PublicHeader />

      <main className="container mx-auto max-w-4xl px-4 py-16">
        <section className="mx-auto max-w-3xl">
          <div className="space-y-7">
            {lines.map((line, index) => (
              <p
                key={line}
                className="text-lg leading-[2.4rem] text-gray-700 sm:text-lg sm:leading-[2.4rem] mr-0"
                style={{
                  transform:
                    index % 2 === 0 ? 'rotate(-0.4deg)' : 'rotate(0.3deg)',
                }}
              >
                {line}
              </p>
            ))}
          </div>

          <div className="mt-16 border-t border-gray-200 pt-10">
            <p className="mx-auto max-w-2xl rounded-3xl bg-white/75 px-6 py-6 text-center text-lg leading-10 text-gray-800 shadow-sm sm:text-lg">
              اگه برای شما هم این قصه‌ها آشناس، ما شبیه هم‌ایم. :)
              <br />
              <span className="mt-4 block text-xl font-semibold text-purple-700 sm:text-xl">
                ما در استارتاپ خجالتی‌ام به دنبال بیان احساس‌های نگفته ایم. جایی
                که سکوت هم حرف می‌زنه. و این... پله‌ی اول ماست.
              </span>
            </p>
          </div>
        </section>
      </main>

      <PublicFooter />
    </div>
  );
};

export default AboutUs;
